export const VALID_PO_BOX_LIST = [
    'PO BOX',
    'P.O. BOX',
    'P O BOX',
    'POBOX',
    'PO_BOX',
    'P. O. BOX',
    'P.O.B',
    'PO-BOX',
    'POST BOX',
    'POST OFFICE BOX',
    'P.O.B.',
    'P/O BOX',
    'P BOX',
    'PB NO',
    'PB NUMBER',
    'P.B. NO',
    'P.B. NUMBER',
    'PO BIN',
    'P.O. BIN'
];
